import React from 'react'
import {Link} from "react-router-dom"

export default function Clients() {
  return (
    <div>
      
      <body background={require('./images/a2.jpg')} >   

      <table align="center" width="900">
          
          <tr>
      
            <td width="200" align="center"> <Link to="/Home"> <h3><font face="Trebuchet" color="white" size="4">Home</font></h3></Link></td>
            <td width="200" align="center"> <Link to="/Products"><h3><font face="Trebuchet" color="white" size="4">Products</font></h3></Link></td>
           
            <td width="200" align="center"> <Link to="/Clients"><h3><font face="Trebuchet" color="white" size="4">Clients</font></h3></Link></td> 
            
            <td width="200" align="center"> <Link to="/Contact"><h3><font face="Trebuchet" color="white" size="4">Contact us</font></h3></Link></td>  
      
          </tr>
      
          </table>
      


          <table align="center" cellspacing="5"  cellpadding="5" >

<tr>


<td  background={require('./images/apricot.jpeg')} width="350"  height="200"><font color="white"> Mr. Amal </font>  </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

<td  background={require('./images/lovi.jpeg')}width="350"  height="200"> <font color="white"> Mr. Bandara </font> </td>


</tr>

<br></br>

<tr>


<td  background={require('./images/red.jpeg')} width="350"  height="200"><font color="white"> Mr. Chamal </font>  </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

<td  background={require('./images/purple1.jpeg')}width="350"  height="200"> <font color="white"> Mr. Darshana </font> </td>


</tr>

<br></br>

<tr>


<td  background={require('./images/green.jpeg')} width="350"  height="200"><font color="white"> Mr. Eranda </font>  </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

<td  background={require('./images/thibbatu.jpeg')}width="350"  height="200"> <font color="white"> Mr. Francis </font> </td>


</tr>

<br></br>

<tr>


<td  background={require('./images/purple2.jpeg')} width="350"  height="200"><font color="white"> Mr. Gayan </font>  </td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

<td  background={require('./images/nidikumba.jpeg')}width="350"  height="200"> <font color="white"> Mr. Harshana </font> </td>


</tr>

</table>

<h4 align="center"> <font size="3" color="white" face="Times New Roman">Developed & Updated on 2024-02-11 by Priyantha Wanninayake  Email : kstpromotions@gmail.com  </font></h4>


   </body>


      </div>
  )
}